import IconComponent from "icons/IconComponent";

import UserIcon from "./user.svg";

export default (UserIcon as any) as IconComponent;
